"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetirementAccountType = void 0;
var RetirementAccountType;
(function (RetirementAccountType) {
    RetirementAccountType["IRA"] = "IRA";
    RetirementAccountType["K_401"] = "401K";
    RetirementAccountType["B_403"] = "403B";
    RetirementAccountType["FOUR57"] = "457";
})(RetirementAccountType = exports.RetirementAccountType || (exports.RetirementAccountType = {}));
